<template>
    <div class="app-loader">
        <img src="@/assets/images/logo.svg" alt="Loading" class="app-loader__logo" />
    </div>
</template>

<style lang="stylus" scoped>
.app-loader
    position fixed
    top 0
    left 0
    width 100vw
    height 100vh
    background var(--app-bg-color)
    display flex
    align-items center
    justify-content center
    z-index 9999

.app-loader__logo
    width 70%
    max-width 300px
    height auto
    animation pulse 1.2s ease-in-out infinite

@keyframes pulse
    0%
        transform scale(1)
    50%
        transform scale(1.06)
    100%
        transform scale(1)
</style>
